import type { GalleryItem } from "@/types/content";

// ---------------------------------------------------------------------------
// GALLERY CONTENT — easy to manage
// ---------------------------------------------------------------------------
// To add a photo: upload it and add a new item to the array below with a
// `title`, `image`, `category` and `alt` text. Nothing else needs to change —
// the gallery page reads this file automatically and only shows the categories
// that actually contain images.
//
// To replace a photo: change the `image` value of that item.
// ---------------------------------------------------------------------------

export const galleryItems: GalleryItem[] = [
  {
    title: "Dr. N. Ajit Kumar",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/f334d67d-5810-4325-9e00-5d6e70a0e5a2_compressed_WhatsApp-Image-2022-11-11-at-21.00.02.webp",
    category: "Doctors",
    alt: "Dr. N. Ajit Kumar, Senior Consultant in Orthopaedic and Spine Surgery at Ortho Spine Care, Trichy",
  },
  {
    title: "Reviewing scans with a patient",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/ee8811ea-fc5e-4082-a5e8-a2841a263ffd_compressed_WhatsApp-Image-2022-10-31-at-18.15.28.webp",
    category: "Clinic",
    alt: "Spine specialist reviewing imaging with a patient during a consultation in Trichy",
  },
  {
    title: "Explaining imaging findings",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/d55319d0-772f-41b8-87bd-0c5ba9e72c0a_compressed_WhatsApp-Image-2022-10-31-at-18.15.29.webp",
    category: "Clinic",
    alt: "Doctor explaining spine scan findings to a patient at the clinic",
  },
  {
    title: "Clinical examination",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/862e9593-7135-4333-9a37-1c6580c2936b_compressed_WhatsApp-Image-2022-10-31-at-18.17.03.webp",
    category: "Treatments",
    alt: "Orthopaedic specialist performing a clinical examination of the spine",
  },
  {
    title: "Understanding your spine",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/526e5953-27f9-4d0f-b6f6-084553398b98_compressed_WhatsApp-Image-2022-10-31-at-18.17.19-1.webp",
    category: "Patient Care",
    alt: "Spine specialist using a spine model to explain a condition to a patient",
  },
  {
    title: "Consultation with family",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/f30b55c1-b8fe-43fb-a2ac-357fb3fb1f1b_compressed_WhatsApp-Image-2022-10-31-at-18.17.19-2.webp",
    category: "Patient Care",
    alt: "Doctor discussing treatment options with a patient and their family member",
  },
  {
    title: "Orthopaedic assessment",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/3d89c16c-c79e-4e63-a304-9f16e4064f91_compressed_WhatsApp-Image-2022-10-31-at-18.17.19.webp",
    category: "Treatments",
    alt: "Orthopaedic assessment of the leg and hip during a specialist consultation",
  },
  {
    title: "Spine examination",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/012905eb-d384-4962-8ff7-17a10d247a3d_compressed_WhatsApp-Image-2022-10-31-at-18.17.20-1.webp",
    category: "Treatments",
    alt: "Spine specialist palpating the back during a clinical examination",
  },
  {
    title: "Patient education",
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/e6eb686e-68be-4e7b-bfc4-efe33c447f16_compressed_WhatsApp-Image-2022-10-31-at-18.17.20.webp",
    category: "Patient Care",
    alt: "Specialist explaining a spine model to a patient while reviewing an X-ray",
  },
];